import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { emptySliceApi } from './emptyApiSlice';
import { adminLayoutSlice } from '../../Admin/adminLayoutSlice';
import { accountSlice } from './shared/accountSlice';
import { userSlice } from './shared/userSlice';
import { sidenavSlice } from '../components/Navigation/apiSlice';
import { hubLayoutSlice } from '../../Hub/hubLayoutSlice';
import { resendSlice } from '../../Admin/People/TabsCard/resendActionSlice';
import { adminUsersLayoutSlice } from '../../Admin/People/TabsCard/UsersTab/adminUsersLayoutSlice';
import { adminInfoSlice } from './shared/adminInfoSlice';
import { impersonationBySlice } from './shared/impersonationBySlice';
import { logListSlice } from './shared/logListSlice';
import { platformTourSlice } from './shared/platformTourSlice';
import { selectedHomeDealSlice } from './shared/selectedHomeDealSlice';
import { activeDealsSlice } from './shared/activeDealsSlice';
import { cartSlice } from './shared/cartSlice';

export const rootReducer = combineReducers({
  user: userSlice.reducer,
  selectedHomeDeal: selectedHomeDealSlice.reducer,
  adminLayout: adminLayoutSlice.reducer,
  account: accountSlice.reducer,
  [emptySliceApi.reducerPath]: emptySliceApi.reducer,
  sidenav: sidenavSlice.reducer,
  hubLayout: hubLayoutSlice.reducer,
  resendList: resendSlice.reducer,
  adminUsersLayout: adminUsersLayoutSlice.reducer,
  adminInfo: adminInfoSlice.reducer,
  impersonatedBy: impersonationBySlice.reducer,
  logList: logListSlice.reducer,
  tutorial: platformTourSlice.reducer,
  activeDeals: activeDealsSlice.reducer,
  cart: cartSlice.reducer,
});

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(emptySliceApi.middleware),
  });
}

export const store = setupStore({});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
